import { MDBTable, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit";
import React, { useState } from "react";
import "../Pages/Style/portfolioreview.css";
import { useContext } from "react";
import { SidebarContext } from "../../context/SidebarContext";
import SideBar from "../Components/SideBar/SideBar";
import TextLinkExample from "../Components/NavBar/NavBar";
import { Feedback } from "../Pages/Feedback";
import Footer from "../Components/Footer/Footer";
import { formatDate } from "../../Constant/utils";
import { useClientDetailQuery } from "../../redux/API/chanelPartnerApi";
import axios from "axios";
import { cpbaseUrl } from "../../Constant/Matcher";
import LogoutCard from "../Components/Card/LogoutCard";

const CPPortfolioReview = () => {
    const [showLogout, setShowLogout] = useState(false);
const { isSiderbaropen } = useContext(SidebarContext);
  const userData = JSON.parse(localStorage.getItem("userData"));
  const userId = userData?.validateEmail[0]?._id;
  const {data: client} = useClientDetailQuery(userId)
const [review, setReview] = useState([])
const handleChage = (e) => {
    const clientid = e.target.value
    if(clientid){
        getData(clientid)
    }
}

    const getData = async (clientid) => {
        axios.get(`${cpbaseUrl}portfolioreview?cpid=${userId}&clientid=${clientid}`).then((res) => {
            setReview(res?.data?.data)
        })
    }
    


  return (
    <>
      <div className="App">
      <SideBar />
      <div className={!isSiderbaropen ? "pages" : "pages-change"}>
        <TextLinkExample setShowLogout={setShowLogout} />
        <div className=" PortfolioReview min-vh-100">
          <div className="PortfolioReviewHeader mx-4 my-4 py-3 px-2 d-flex justify-content-between align-items-center">
            <h4 className='mb-0'>Portfolio Review</h4>
            <div>
                <select name="" id="" className="form-select " onChange={handleChage}>
                    <option value="">Select Client</option>
                    {
                        client && client?.cplist?.map((result) => (
                            <option key={result?.client[0]?._id} value={result?.client[0]?._id}>{result?.client[0]?.name}</option>
                        ))
                    }
                </select>
            </div>
          </div>
          <div className="PortfolioReviewTable mx-4 my-4">
            <MDBTable
              hover
              striped
              style={{ backgroundColor: "RGB(255 255 255)" }}
            >
              <MDBTableHead
                style={{ backgroundColor: "#5A4344", color: "white" }}
              >
                <tr>
                  <th scope="col">Last Review Date</th>
                  <th scope="col">Next Review Date</th>
                  <th scope="col">Done By</th>
                  <th scope="col">Remarks</th>
                </tr>
              </MDBTableHead>
              
              <MDBTableBody>
                {review &&
                  review?.map((result) => {
                    const reviewDate = new Date(result?.reviewdonedate);
                    reviewDate.setMonth(reviewDate.getMonth() + result?.clientdata[0]?.reviewduration);

                    const reviewFormat = reviewDate.toLocaleDateString(
                      "en-US",
                      {
                        month: "2-digit",
                        day: "2-digit",
                        year: "numeric",
                      }
                    );

                    return (
                      <tr>
                        <td>{formatDate(result?.reviewdonedate)}</td>
                        <td>{formatDate(reviewFormat)}</td>
                        <td>{result?.reviewdoneBy}</td>
                        <td>{result?.reviewremark}</td>
                      </tr>
                    );
                  })}
                 {
                  review && review?.length === 0 && (
                    <tr>
                        <td colSpan={4} className="text-center">Select Client to View Portfolio Review</td>
                      </tr>
                  )

                 }
              </MDBTableBody>
            </MDBTable>
          </div>
        </div>
        <Footer />
      </div>
      <Feedback />
    </div>
    {showLogout && <LogoutCard setShowLogout={setShowLogout} />}
    </>
  )
}

export default CPPortfolioReview